// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ExtrasEdit_pageHeader__19ffw ExtrasList_pageHeader__1iaQm","editSection":"ExtrasEdit_editSection__3nyKS","archiveText":"ExtrasEdit_archiveText__1oMHU"};